import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { RadioButtonGroup, useWatch, TextareaAutosizeElement, DatePickerElement } from 'react-hook-form-mui';
import GenericModalForm from '../GenericModalForm';
import ar from './ar.json';
import en from './en.json';
import {  IntlProvider } from 'react-intl';
import BasicEnquiryFormFields from '../../../atoms/BasicEnquiryFormFields';
import dayjs from 'dayjs';
import { LocaleContext } from '../../../../contexts/language';
import PropTypes from 'prop-types';


const languages = {
  ar,
  en
};

const CallBackDateTimeSection = ({ loading }) => {
  const { callBackASAP: callBackASAP } = useWatch('callBackASAP');

  if (callBackASAP === 'asap') {
    return null;
  }

  return (
    <>

      <Grid xs={12} md={6}>
        <DatePickerElement
          sx={{ width: '100%' }}
          disabled={loading}
          minDate={dayjs().add(1, 'day')}
          parseError={(err) => err?.message}
          fullWidth
          name={'callBackDate'}
          // required
          label={'When would you like us to call?'}
          helperText={'Select a date that you want us to contact you'}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <RadioButtonGroup
          label={'What time of day?'}
          name={'timeOfDay'}
          disabled={loading}
          fullWidth
          parseError={(err) =>
            err.type === 'required' ? 'Select at least one option' : err.message
          }
          // helperText={'Select which role(s) they have within your organization'}
          options={[
            {
              id: 'any',
              label: 'Any Time'
            },
            {
              id: 'morning',
              label: 'Morning'
            },
            {
              id: 'afternoon',
              label: 'Afternoon'
            },
            {
              id: 'evening',
              label: 'Evening'
            }
          ]}
        />
      </Grid>

    </>
  );
};


export const CallbackFormModal = ({ onSubmit, ...rest }) => {

  const localeConfig = React.useContext(LocaleContext);
  return (
    <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
      <GenericModalForm
        {...rest}
        onSubmit={({ formValues:{ testDriveDate,...rest } })=>onSubmit({ formValues:{ ...rest,testDriveDate:testDriveDate.format('YYYY-MM-DD') } })}
        defaultValues={{
          ...rest,
          firstName: '',
          lastName: '',
          message: '',
          emailAddress: '',
          phoneNumber: '',
          callBackDate: dayjs().add(1, 'day'),
          callBackASAP: 'asap'
        }}
        // editTitle={'Edit Person'}
        addTitle={'Send an Enquiry'}
        editTitle={'Send an Enquiry'}
        onSubmitText={'Send Enquiry'}
        onSubmitTitle={'Ask a question'}
        onNewSnackText={'Callback request was sent successfully'}
        onEditSnackText={'Enquiry Sent successfully'}>
        {({ loading }) => (
          <>
            <BasicEnquiryFormFields loading={loading} />
            <Grid xs={12} md={6}>
              <RadioButtonGroup
                label={'When should we call you?'}
                name={'callBackASAP'}
                disabled={loading}
                fullWidth
                parseError={(err) =>
                  err.type === 'required' ? 'Select at least one option' : err.message
                }
                // helperText={'Select which role(s) they have within your organization'}
                options={[
                  {
                    id: 'asap',
                    label: 'As Soon As Possible'
                  },
                  {
                    id: 'dateAndTime',
                    label: 'At a specified Date/Time'
                  }
                ]}
              />
            </Grid>
            <CallBackDateTimeSection loading={loading} />
            <Grid xs={12}>
              <TextareaAutosizeElement
                disabled={loading}
                fullWidth
                minRows={3}
                name={'message'}
                label={'Message'}
                helperText={'Do you have a specific question you want help with?'}
                validation={{
                  minLength: { value: 1, message: 'Value is too short' },
                  maxLength: { value: 4000, message: 'Value is too long' },
                  // required: 'This field is required'
                  // pattern: {value: /^[A-Za-z]+$/i, message: 'The value is invalid, only a single word is allowed'},
                }}

              />
            </Grid>
          </>
        )}
      </GenericModalForm>
    </IntlProvider>
  );
};

CallbackFormModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
CallbackFormModal.defaultProps = {
  onClose: () => {
  },
  open: false
};
export default CallbackFormModal;